<nz-modal
  nzWrapClassName="vertical-center-modal"
  nzClassName="watchlist-modal-container"
  [(nzVisible)]="visible"
  nzTitle="Manage Watchlists"
  [nzWidth]="modalWidth"
  (nzOnCancel)="handleCancelModal()"
  [nzFooter]="null"
>
  <div *nzModalContent class="manage-watchlist-container">
    <button
      [ngClass]="checkedIds.size > 0 ? 'error-button' : 'delete-button'"
      (click)="showWarningModal()"
    >
      Delete Selected
    </button>
    <nz-table
      #rowSelectionTable
      [nzData]="watchlistData"
      nzFrontPagination="false"
      [nzShowPagination]="false"
      [nzScroll]="{ y: '196px' }"
    >
      <thead>
        <tr>
          <th
            nzShowCheckbox
            class="checkbox-black"
            nzWidth="50px"
            [(nzChecked)]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onCheckAll($event)"
          ></th>
          <th>Name</th>
          <th nzWidth="130px"># of Company</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of watchlistData">
          <td
            nzShowCheckbox
            class="checkbox-black"
            [nzChecked]="checkedIds.has(row.w_id)"
            (nzCheckedChange)="onRowChecked(row.w_id, $event)"
            *ngIf="row.w_id !== -1"
          ></td>

          <td *ngIf="row.w_id !== -1">
            <span
              *ngIf="row.w_owner_name !== undefined"
              nz-popover
              [nzPopoverContent]="sharedWatchlistNameTooltipTemplate"
              nzPopoverPlacement="right"
            >
              <span>{{ row.w_name | textEllipsis: 15 }}</span
              ><span> by </span
              ><span>{{ row.w_owner_name | textEllipsis: 15 }}</span>
            </span>

            <span
              *ngIf="row.w_owner_name === undefined"
              nz-popover
              [nzPopoverContent]="watchlistNameTooltipTemplate"
              nzPopoverPlacement="right"
            >
              {{ row.w_name | textEllipsis: 24 }}
            </span>
          </td>

          <td class="align-right" *ngIf="row.w_id !== -1">
            {{ row.w_cmp_cnt }}
          </td>

          <ng-template #sharedWatchlistNameTooltipTemplate>
            <div class="tooltip-template">
              <span>
                {{ row.w_name + " by " + row.w_owner_name }}
              </span>
            </div>
          </ng-template>

          <ng-template #watchlistNameTooltipTemplate>
            <div class="tooltip-template">
              <span>
                {{ row.w_name }}
              </span>
            </div>
          </ng-template>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-modal>

<!-- Delete confirmation modal -->
<nz-modal
  nzWrapClassName="vertical-center-modal"
  [(nzVisible)]="showDeleteConfirmationModal"
  nzTitle=""
  (nzOnCancel)="handleDeleteModalCancel()"
  [nzClassName]="'restart-modal'"
  nzWidth="450"
>
  <div *nzModalContent class="delete-confirmationmodal-container">
    <div class="icon-col">
      <va-icon name="exclamation-triangle" class="error-color"></va-icon>
    </div>
    <div class="text-col">
      <h3 class="header-4">
        Delete this watchlist?
      </h3>
      <p>
        Once a watchlist is deleted, you will also lose its
        <span class="highlight-alerts-link">Alerts and Sharing settings</span>.
      </p>
    </div>
  </div>
      <div *nzModalFooter nz-row nzType="flex" nzJustify="end" [nzGutter]="8">
        <div nz-col>
          <va-button
            btnType="outline"
            size="medium"
            (click)="handleDeleteModalCancel()"
            class="watchlist-btn"
          >
            Cancel
          </va-button>
        </div>
        <div nz-col>
          <va-button
            btnType="solid"
            size="medium"
            state="error"
            (click)="deleteSelectedWatchlists()"
          >
            Delete
          </va-button>
        </div>
      </div>
</nz-modal>
